// extracted by mini-css-extract-plugin
export default {"modal":"EditProject_modal__Sz2Zx","modalDialog":"EditProject_modalDialog__RSIlT","center":"EditProject_center__veoXO","p":"EditProject_p__thfz7","row":"EditProject_row__+eZvC"};